import {
  FormLabel,
  FormLabelProps,
  HTMLWrapper,
  VisuallyHidden
} from "@/storybook-components";

interface QuestionTitleProps extends FormLabelProps {
  id?: string;
  isRequired?: boolean;
  labelType?: "label" | "legend" | "fieldset";
  labelClassName?: string;
  accessibilityTextOfRequired?: string;
  children: string;
}

const QuestionTitle = (props: QuestionTitleProps): JSX.Element => {
  const {
    id,
    isRequired,
    children,
    labelClassName,
    labelType = "label",
    accessibilityTextOfRequired,
    htmlFor,
    ...rest
  } = props;

  return (
    <FormLabel
      id={id}
      htmlFor={htmlFor}
      className={labelClassName}
      as={labelType}
      mb={0}
      {...rest}
    >
      <HTMLWrapper html={children} isFullWidth />
      {isRequired && accessibilityTextOfRequired && (
        <VisuallyHidden>{accessibilityTextOfRequired}</VisuallyHidden>
      )}
    </FormLabel>
  );
};

export { QuestionTitle };
export type { QuestionTitleProps };
